import config from 'config';

const build = (path: string) => `${config.docroot}${path}`;

export const LOGIN_PATH = build('login');
export const OPENID_LOGIN_CALLBACK_PATH = build('login/callback');
export const ACCESS_DENIED_PATH = build('access-denied');

export const DASHBOARD_PATH = build('');
export const FEATURE_LIST_PATH = build('features');
export const FEATURE_VIEW_PATH = build('features/:featureToken');
export const FEATURE_EDIT_PATH = build('features/:featureToken/edit');
export const FEATURE_CREATE_PATH = build('features/new');
export const TOGGLE_LIST_PATH = build('toggles');
export const AUDIENCE_PATH = build('audience');
export const REQUESTER_LIST_PATH = build('audience/requesters');
export const REQUESTER_VIEW_PATH = build('audience/requesters/:requesterToken');
export const REQUESTER_EDIT_PATH = build('audience/requesters/:requesterToken/edit');
export const REQUESTER_CREATE_PATH = build('audience/requesters/new');
export const REQUESTER_TOKEN_LIST_PATH = build('audience/tokens');
export const REQUESTER_TOKEN_VIEW_PATH = build('audience/tokens/:requesterTokenToken');
export const REQUESTER_TOKEN_EDIT_PATH = build('audience/tokens/:requesterTokenToken/edit');
export const REQUESTER_TOKEN_CREATE_PATH = build('audience/tokens/new');

export const NOT_FOUND_PATH = build('not-found');

const buildCommonSearchPath = (basePath: string, searchQuery?: string, page?: string) =>
{
  const query = [];
  if (searchQuery && searchQuery !== '')
  {
    query.push(`q=${searchQuery}`);
  }
  if (page && page !== '')
  {
    query.push(`p=${page}`);
  }
  return basePath + (query.length > 0 ? '?' + query.join('&') : '');
};

export const buildAbsolutePath = (path: string) => `${window.location.origin}${path}`;
export const buildOpenIdLoginPath = () => OPENID_LOGIN_CALLBACK_PATH;
export const buildAccessDeniedPath = () => ACCESS_DENIED_PATH;

export const buildDashboardPath = () => DASHBOARD_PATH;
export const buildLoginPath = () => LOGIN_PATH;

export const buildFeatureListPath = (searchQuery?: string, page?: string) => buildCommonSearchPath(FEATURE_LIST_PATH, searchQuery, page);
export const buildFeatureViewPath = (featureToken: string) => FEATURE_VIEW_PATH.replace(':featureToken', featureToken);
export const buildFeatureEditPath = (featureToken: string) => FEATURE_EDIT_PATH.replace(':featureToken', featureToken);
export const buildFeatureCreatePath = () => FEATURE_CREATE_PATH;

export const buildToggleListPath = (searchQuery?: string, page?: string) => buildCommonSearchPath(TOGGLE_LIST_PATH, searchQuery, page);

export const buildAudiencePath = () => AUDIENCE_PATH;
export const buildRequesterListPath = (searchQuery?: string, page?: string) => buildCommonSearchPath(REQUESTER_LIST_PATH, searchQuery, page);
export const buildRequesterViewPath = (requesterToken: string) => REQUESTER_VIEW_PATH.replace(':requesterToken', requesterToken);
export const buildRequesterEditPath = (requesterToken: string) => REQUESTER_EDIT_PATH.replace(':requesterToken', requesterToken);
export const buildRequesterCreatePath = () => REQUESTER_CREATE_PATH;

export const buildRequesterTokenListPath = (searchQuery?: string, page?: string) => buildCommonSearchPath(REQUESTER_TOKEN_LIST_PATH, searchQuery, page);
export const buildRequesterTokenViewPath = (requesterTokenToken: string) => REQUESTER_TOKEN_VIEW_PATH.replace(':requesterTokenToken', requesterTokenToken);
export const buildRequesterTokenEditPath = (requesterTokenToken: string) => REQUESTER_TOKEN_EDIT_PATH.replace(':requesterTokenToken', requesterTokenToken);
export const buildRequesterTokenCreatePath = () => REQUESTER_TOKEN_CREATE_PATH;

export const buildNotFoundPath = () => NOT_FOUND_PATH;

export const isLoginPath = (uri: string) => (uri === buildLoginPath() || uri.startsWith(`${buildLoginPath()}/`));
